import { useIntl } from 'react-intl'

import { useAppSelector } from 'app/hooks'
import { activeSubscriptionSelector } from 'features/home/selectors'
import { commonMessages } from 'app/i18n/messages'

import { formatRecurringPrice } from '../../utils'
import { SubsUpdateRightPanelContainer } from './styles'
import UpdatePlanBlock from './UpdatePlanBlock'

function SubsUpdateRightPanel() {
  const { formatMessage } = useIntl()
  const subscriptionInfo = useAppSelector(activeSubscriptionSelector.data)
  const selectedPlan = subscriptionInfo.stripePrice

  const selectedPlanPrice = formatRecurringPrice(
    selectedPlan?.unit_amount,
    selectedPlan?.interval,
    formatMessage
  )
  return (
    <SubsUpdateRightPanelContainer>
      <UpdatePlanBlock
        selectedPlanName={formatMessage(commonMessages.essentialPlan)}
        selectedPlanPrice={selectedPlanPrice}
      />
    </SubsUpdateRightPanelContainer>
  )
}

export default SubsUpdateRightPanel
